import gql from 'graphql-tag';
export default gql`
  mutation UpdateTableById($input: UpdateTableByIdInput!) {
    updateTableById(input: $input) {
      clientMutationId
    }
  }
`;
